import { createSlice, createSelector } from '@reduxjs/toolkit';
import { fetchPcaModel, fetchCopulaModel } from "../../api/analyticsApi";

const initialState = {
  models: {},
  latestModel: null,
  status: 'idle',
  error: null,
}

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    const addModelCases = (thunk) => {
      builder
        .addCase(thunk.pending, (state) => {
          state.status = 'loading';
        })
        .addCase(thunk.fulfilled, (state, action) => {
          state.status = 'succeeded';
          const { symbols, startDate, endDate } = action.meta.arg;
          const key = `${action.payload.modelName}_${symbols.join(',')}_${startDate}_${endDate}`;
          state.models[key] = action.payload;
          state.latestModel = key;
        })
        .addCase(thunk.rejected, (state, action) => {
          state.status = 'failed';
          state.error = action.payload;
        });
    };

    addModelCases(fetchPcaModel);
    addModelCases(fetchCopulaModel);
  },
});

export const selectModels = (state) => state.analytics.models;
export const selectLatestModel = (state) => state.analytics.latestModel;
export const selectStatus = (state) => state.analytics.status;
export const selectError = (state) => state.analytics.error;

export const selectLatestModelData = createSelector(
  [selectModels, selectLatestModel],
  (models, latestKey) => latestKey ? models[latestKey] : null
);

export default analyticsSlice.reducer;